module.exports = __webpack_public_path__ + "static/media/42_A.c47bcc56.png";